import { CSSProperties, FC, ReactNode } from "react";
import classNames from "classnames";
import "./AilenaxBox.css";

interface AilenaxBoxProps {
    children: ReactNode;
    theme?: "none" | "rainbow" | "ice" | "fuerte";
    className?: string;
    style?: CSSProperties;
}

export const AilenaxBox: FC<AilenaxBoxProps> = ({ children, theme = "rainbow", className, style }) => {
    return (
        <div className={classNames("ailenax-box", `theme-${theme}`, className)} style={style}>
            {children}
        </div>
    );
}